import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { HEALTH_DISCLAIMER } from "@/config/site";

export const Disclaimer = ({ compact = false, className = "" }) => (
  <aside
    className={`rounded-2xl border p-5 sm:p-6 ${className}`}
    style={{ background: "#F3F1EA", borderColor: "rgba(138,101,72,0.22)" }}
    aria-label="Health disclaimer"
    data-testid="health-disclaimer"
  >
    <div className="flex gap-3">
      <Info className="mt-0.5 h-5 w-5 shrink-0" style={{ color: "#6B4C35" }} aria-hidden="true" />
      <div className="space-y-2 text-sm leading-relaxed text-[#3d4a42]">
        <p className="font-semibold text-[#25332B]">Health disclaimer</p>
        {(compact ? HEALTH_DISCLAIMER.slice(1) : HEALTH_DISCLAIMER).map((t) => (
          <p key={t}>{t}</p>
        ))}
        <Link to="/health-disclaimer" className="link-accent text-sm" data-testid="health-disclaimer-link">
          Read the full health disclaimer
        </Link>
      </div>
    </div>
  </aside>
);
